import React from 'react';
import Fade from 'react-reveal/Fade'
import { Button,ButtonDes,ButtonLinkCV } from './InfoElements'
import { InfoContainer, InfoWrapper, InfoRow, Column1, Column2, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, ImgWrap, Img } from './InfoElements'

const InfoSection = ({lightBg,id,imgStart,topLine,lightText,headline,darkText,description,description_1,buttonLabel,buttonCV,ImgSv,primary,dark,dark2}) => {
    return (
        <>
           <InfoContainer lightBg={lightBg} id={id}>
               <InfoWrapper>
                   <InfoRow imgStart={imgStart}>
                       <Column1>
                            <Fade top>
                                <TextWrapper>
                                    <TopLine>
                                        {topLine}
                                    </TopLine>
                                    <Heading lightText={lightText}>
                                        {headline}
                                    </Heading>
                                    <Subtitle darkText={darkText}>
                                        {description}
                                    </Subtitle>
                                    <Subtitle darkText={darkText}>
                                        {description_1}
                                    </Subtitle>
                                    <BtnWrap>
                                        <Button 
                                            to="/Experiencie"
                                            primary={primary}
                                            dark={dark ? 1 : 0}
                                            dark2={dark2 ? 0 : 1}
                                        >{buttonLabel}
                                        </Button>

                                        <ButtonDes>
                                            <ButtonLinkCV href="http://curriculum.eljimmyramz.com/assets/Ramirez_Osorio_Jaime_Ivan.pdf" download="CV Jaime Ivan Ramirez Osorio" rel="noopener noreferrer">
                                                {buttonCV}
                                            </ButtonLinkCV>
                                        </ButtonDes>
                                    </BtnWrap>
                                </TextWrapper>
                            </Fade>
                       </Column1>
                       <Column2>
                        <Fade bottom>
                            <ImgWrap>
                              <Img loading="lazy" src={ImgSv} alt="Jaime Ivan Ramirez Osorio eljimmyramz" title="Jaime Ivan Ramirez Osorio eljimmyramz" width="100%" height="100%" />
                            </ImgWrap>
                        </Fade>
                       </Column2>
                   </InfoRow>
               </InfoWrapper>
            </InfoContainer> 
        </>
    )
}

export default InfoSection
